import { GetPromotionStatusResponse } from '@intelligent-play-v2/domain';
import { queryBuilder } from '~/api';

/** Whether this deployment can promote facilities anywhere, and where. */
export const getPromotionStatus = async (): Promise<GetPromotionStatusResponse> => {
  const { data } = await queryBuilder('GET', 'onboarding/promotion');
  return data;
};
